export const setTicketId = id => ({ type: 'SET_TICKET_ID', payload: id });
export const toggleModal = () => ({ type: 'TOGGLE_MODAL' });
export const reloadTickets = () => ({ type: 'RELOAD_TICKETS' });
